// This file is generated.
export var version = '0.3.5';
//# sourceMappingURL=version.js.map